import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  resetPersonalDataApiService,
  type ResetPersonalDataResponse,
} from "@/generated/fastapi";

export async function resetPersonalData(
  accessToken: string | null | undefined,
) : Promise<ResetPersonalDataResponse> {
  const response = await resetPersonalDataApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
  });

  if (response.status !== 200 || !response.data) {
    throw new Error("Failed to reset personal data");
  }

  return response.data;
}
